import ArticleCard from '@/components/ArticleCard';
import { useIsMobile } from '@/hooks/useIsMobile';
import type { article } from '@/types/articles';

interface HeroArticlesProps {
  articles: article[];
}

function HeroArticles({ articles }: HeroArticlesProps) {
  const isMobile = useIsMobile();

  return (
    <div className='mx-auto' data-cy='hero-articles'>
      {articles.length > 3 && (
        <div className='md:grid md:grid-cols-[4fr_5fr] md:grid-rows-[repeat(2,minmax(200px,1fr))] md:gap-6'>
          <div className='md:col-span-1 md:row-span-2'>
            <ArticleCard
              article={articles[1]}
              background='white'
              imagePosition='top'
              layout='halfImage'
              className='md:row-span-2'
            />
          </div>
          <div>
            <ArticleCard article={articles[2]} layout='noImageMobile' background={isMobile ? 'grey' : 'white'} />
          </div>
          <div>
            <ArticleCard article={articles[3]} layout='noImageMobile' background={isMobile ? 'grey' : 'white'} />
          </div>
        </div>
      )}
    </div>
  );
}

export default HeroArticles;
